import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=4be6a1a5&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=ts&"
export * from "./Token.vue?vue&type=script&lang=ts&"
import style0 from "./Token.vue?vue&type=style&index=0&id=4be6a1a5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6a1a5",
  null
  
)

export default component.exports